export default "__VITE_ASSET__daef4d57__"